import { Outlet } from 'react-router-dom';

import routes from '@routes';
import { Page } from '@common/ui/Page';
import RequestDrawer from '../organisms/RequestDrawer';

export default function RequestsLayout() {
  const tabs = [
    { label: routes.OpenRequests.label, to: routes.OpenRequests.path },
    {
      label: routes.ClosedRequests.label,
      to: routes.ClosedRequests.path,
    },
    {
      label: routes.Templates.label,
      to: routes.Templates.path,
    },
  ];

  return (
    <Page
      title="My Requests"
      tabs={tabs}
      button={{
        label: 'New Request',
        href: routes.NewRequest.path,
      }}
    >
      <Outlet />
      <RequestDrawer />
    </Page>
  );
}
